import React from "react";

const TextDetailHolder = ({ heading, value }) => {
  return (
    <div className={`text-detail-holder`}>
      <p className={`heading`}>{heading}</p>
      <p className={`detail`}>{value || value === 0 ? value : "-------"}</p>
    </div>
  );
};

export default TextDetailHolder;
